import { ThemeFamilies } from './types';
var getExceptionList = function (colors) {
    var _a;
    return (_a = {},
        _a[ThemeFamilies.PRIMARY] = {
            main: colors.primary,
            text: colors.primary,
        },
        _a[ThemeFamilies.SECONDARY] = {
            main: colors.secondaryText,
            text: colors.secondaryText,
        },
        _a[ThemeFamilies.WARNING] = {
            main: colors.warning,
            text: colors.secondaryText,
        },
        _a[ThemeFamilies.ERROR] = {
            main: colors.error,
            text: colors.secondaryText,
        },
        _a);
};
export default getExceptionList;
